module.exports = function() {
    return new this.PopupWidget(this);
};